import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const AirplaneCircleIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "AirplaneCircleGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.1799 22C6.66597 22 2.17993 17.514 2.17993 12C2.17993 6.48603 6.66597 2 12.1799 2C17.6939 2 22.1799 6.48603 22.1799 12C22.1799 17.514 17.6939 22 12.1799 22ZM12.1799 3.00343C7.21913 3.00343 3.18336 7.03969 3.18336 12C3.18336 16.9603 7.21913 20.9966 12.1799 20.9966C17.1407 20.9966 21.1765 16.9603 21.1765 12C21.1765 7.03969 17.1407 3.00343 12.1799 3.00343Z"
        fill="#FC3B26"
      />
      <path
        d="M12.1863 17.7942C11.7978 17.7942 11.4514 17.5924 11.2583 17.2553L10.9065 16.6399C10.7654 16.393 10.691 16.1127 10.691 15.8285V13.2582L7.45774 12.0666C7.26029 11.9941 7.12947 11.807 7.12947 11.5963V10.2469C7.12947 10.1 7.19365 9.96081 7.30536 9.86577C7.41707 9.77072 7.56259 9.72858 7.71006 9.75111L10.691 10.2244V8.78492L9.8639 8.20482C9.73015 8.11075 9.65028 7.95788 9.65028 7.79423V6.70751C9.65028 6.54974 9.72427 6.40177 9.8497 6.30673C9.97611 6.21266 10.1383 6.1813 10.2892 6.22442L12.2054 6.76925L14.0672 6.22638C14.2181 6.18032 14.3823 6.2107 14.5087 6.30575C14.6351 6.40079 14.7096 6.54974 14.7096 6.70751V7.79423C14.7096 7.95592 14.6317 8.10781 14.4999 8.20188L13.6689 8.79766V10.2381L16.6479 9.7521C16.7919 9.72466 16.9418 9.76974 17.0535 9.86478C17.1657 9.95984 17.2304 10.1 17.2304 10.2469V11.5963C17.2304 11.805 17.1011 11.9922 16.9056 12.0657L13.6689 13.2866V15.8354C13.6689 16.1117 13.5979 16.3861 13.4631 16.6291L13.1207 17.2455C12.9335 17.5816 12.5773 17.7923 12.1917 17.7942L12.1863 17.7942ZM8.1329 11.2465L11.3661 12.438C11.5636 12.5105 11.6944 12.6977 11.6944 12.9084V15.8285C11.6944 15.9383 11.7233 16.047 11.7777 16.1421L12.13 16.7575L12.6821 17.0015L12.2436 16.7575L12.5856 16.1431C12.6376 16.049 12.6655 15.9422 12.6655 15.8354V12.9398C12.6655 12.731 12.7948 12.5439 12.9903 12.4704L16.227 11.2494V10.8369L13.248 11.3229C13.103 11.3484 12.9541 11.3053 12.8424 11.2102C12.7302 11.1152 12.6655 10.975 12.6655 10.8281V8.53996C12.6655 8.37828 12.7434 8.22639 12.8752 8.13232L13.7061 7.53653V7.37681L12.348 7.77269C12.2568 7.80012 12.1613 7.80012 12.0702 7.77465L10.6537 7.3719V7.53358L11.4808 8.11369C11.6145 8.20776 11.6944 8.36062 11.6944 8.52427V10.8124C11.6944 10.9593 11.6302 11.0985 11.5185 11.1935C11.4068 11.2896 11.2603 11.3297 11.1138 11.3082L8.13289 10.8349L8.1329 11.2465Z"
        fill="#FC3B26"
      />
    </svg>
  );
};

export default AirplaneCircleIcon;
